import { useContext } from 'react'
import { FlashMessageContext } from 'shared/common/flashMessages/FlashMessageProvider'

function FlashMessagesContainer() {
  const { currentFlashMessage } = useContext(FlashMessageContext)
  return currentFlashMessage || null
}

export default FlashMessagesContainer
